
import React from 'react';
import { cn } from '@/lib/utils';

interface HeaderProps {
  title: string;
  description?: string;
  className?: string;
  children?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ 
  title, 
  description, 
  className,
  children 
}) => {
  return (
    <div className={cn("flex flex-col space-y-2 pb-8 pt-6", className)}>
      <div className="flex justify-between items-start">
        <div className="space-y-1">
          <h1 className="text-3xl font-semibold tracking-tight text-yellow">{title}</h1>
          {description && (
            <p className="text-muted-foreground">{description}</p>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default Header;
